import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { LaborScheduleEntry } from 'src/app/shared/models/laborScheduling/LaborScheduling.model';

@Component({
	selector: 'app-employee-schedule-time',
	templateUrl: './employee-schedule-time.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class EmployeeScheduleTimeComponent implements OnInit {
	@Input() scheduleEntry: LaborScheduleEntry;
	@Output() scheduleEntryChange = new EventEmitter<LaborScheduleEntry>();

	@Output() scheduleEventSelected = new EventEmitter<any>();

	constructor(public app: AppService) {}

	ngOnInit(): void {}
}
